module.exports = __webpack_public_path__ + "static/media/stairs.63fffa12.jpg";